import { render, staticRenderFns } from "./ResAccess.vue?vue&type=template&id=472afd24&scoped=true&"
import script from "./ResAccess.vue?vue&type=script&lang=js&"
export * from "./ResAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472afd24",
  null
  
)

export default component.exports